import React from 'react';
import { WarningIcon } from 'components/Icon/Custom';
import { Space, VerticalSpace } from 'components/Space';
import { Title } from 'components/Typography/Title';
import { Text } from 'components/Typography';
import { Button } from 'components/Button';
import { spacing } from 'constants/spacing';
import { commonProps } from '../constants';
import { IStatusChildrenProps } from '../types';
import { useStatusPageHandlers } from '../useStatusPageHandlers';
import { Wrapper } from './styled';

const Forbidden: React.FC<IStatusChildrenProps> = ({ isSaas, additionalDescription }) => {
  const { handleGoToMain, handleRequestSupport } = useStatusPageHandlers();

  return (
    <Wrapper>
      <VerticalSpace size={20} {...commonProps}>
        <WarningIcon />

        <VerticalSpace size={spacing.md} {...commonProps}>
          <VerticalSpace size={spacing.sm} {...commonProps}>
            <VerticalSpace size={spacing.xxs} {...commonProps}>
              <Title level='h6'>Доступ запрещен</Title>

              <VerticalSpace size={0} {...commonProps}>
                <Text color='gray650'>У вас нет прав на просмотр этой страницы.</Text>
                <Text color='gray650'>
                  Обратитесь в поддержку, чтобы запросить доступ
                </Text>
              </VerticalSpace>

              {additionalDescription && (
                <Text color='gray650'>{additionalDescription}</Text>
              )}
            </VerticalSpace>
          </VerticalSpace>

          <Space>
            <Button variant={isSaas ? 'secondary' : 'primary'} onClick={handleGoToMain}>
              Перейти на главную
            </Button>
            {isSaas && (
              <Button variant='primary' onClick={handleRequestSupport}>
                Написать в поддержку
              </Button>
            )}
          </Space>
        </VerticalSpace>
      </VerticalSpace>
    </Wrapper>
  );
};

export default Forbidden;
